import React, { useEffect } from 'react';
import { 
  Paper, 
  Typography, 
  Button, 
  Box,
  Alert
} from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleGoogleLogin = () => {
    // Redirect to Google OAuth
    const clientId = 'YOUR_GOOGLE_OAUTH_CLIENT_ID';
    const redirectUri = encodeURIComponent(`${window.location.origin}/auth/callback`);
    const scope = encodeURIComponent('email profile');
    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=token&scope=${scope}`;
    
    window.location.href = authUrl;
  };

  // Handle OAuth callback
  useEffect(() => {
    const handleOAuthCallback = async () => {
      const hash = window.location.hash.substring(1);
      const params = new URLSearchParams(hash);
      const token = params.get('access_token');
      
      if (token) {
        try {
          // Verify token with our backend
          const response = await fetch('/api/auth/verify', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token })
          });
          
          const result = await response.json();
          
          if (result.success) {
            login(result.user);
            navigate('/dashboard');
          } else {
            alert('Authentication failed: ' + result.error);
          }
        } catch (error) {
          alert('Authentication error: ' + error.message);
        }
      }
    };

    if (window.location.hash) {
      handleOAuthCallback();
    }
  }, [login, navigate]);

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
      <Paper elevation={3} style={{ padding: '40px', maxWidth: '400px', width: '100%', textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom style={{ color: '#1976d2' }}>
          Artha Bhaskar
        </Typography>
        
        <Typography variant="body1" color="textSecondary" style={{ marginBottom: '30px' }}>
          VAT Accounting System
        </Typography>

        <Button
          variant="contained"
          startIcon={<GoogleIcon />}
          onClick={handleGoogleLogin}
          style={{
            backgroundColor: '#4285f4',
            padding: '12px 24px',
            fontSize: '16px'
          }}
          fullWidth
          size="large"
        >
          Sign in with Google
        </Button>
        
        <Alert severity="info" style={{ marginTop: '20px' }}>
          Only authorized Google accounts can access this system.
        </Alert>
      </Paper>
    </Box>
  );
}

export default Login;